import client from '../../../common/client';
import uuid from 'uuid';

export const CANCEL_SESSION_FOR_MS = 'CANCEL_SESSION_FOR_MS';
export const COMPLETE_SESSION = 'COMPLETE_SESSION';
export const GET_MS_ADMIN_SESSIONS = 'GET_MS_ADMIN_SESSIONS';
export const RESPOND_TO_SESSION = 'RESPOND_TO_SESSION';
export const UPDATE_MOVEMENT_SPECIALIST_PROFILE = 'UPDATE_MOVEMENT_SPECIALIST_PROFILE';
export const CONNECT_STRIPE_EXPRESS_ACCOUNT = 'CONNECT_STRIPE_EXPRESS_ACCOUNT';
export const GET_STRIPE_EXPRESS_LOGIN_LINK = 'GET_STRIPE_EXPRESS_LOGIN_LINK';

export const updateMovementSpecialistProfile = (userId, values) => {
  const data = new FormData();
  if (values.profile_image_id) data.append('profile_image_id', values.profile_image_id);
  if (values.profile_image) data.append('profile_image', values.profile_image, uuid.v4());
  if (values.header_image_id) data.append('header_image_id', values.header_image_id);
  if (values.header_image) data.append('header_image', values.header_image, uuid.v4());

  data.append('availability', values.availability);
  data.append('biography', values.biography);
  data.append('longitude', values.longitude);
  data.append('latitude', values.latitude);
  data.append('location_short', values.location_short);
  data.append('location_long', values.location_long);
  data.append('name', values.name);

  return {
    promise: client.put(`users/${userId}/movement-specialist-profile`, data),
    type: UPDATE_MOVEMENT_SPECIALIST_PROFILE,
  };
};

export const getSessions = userId => {
  return {
    promise: client.get(`movement-specialists/${userId}/sessions`),
    type: GET_MS_ADMIN_SESSIONS,
  };
};

export const respondToSessionRequest = (userId, sessionId, values) => {
  return {
    promise: client.patch(`movement-specialists/${userId}/sessions/${sessionId}/respond`, values),
    type: RESPOND_TO_SESSION,
  };
};

export const cancelBookedSession = (userId, sessionId, values) => {
  return {
    promise: client.patch(`movement-specialists/${userId}/sessions/${sessionId}/cancel`, values),
    type: CANCEL_SESSION_FOR_MS,
    sessionId,
  };
};

export const completeSession = (userId, sessionId) => {
  return {
    promise: client.patch(`movement-specialists/${userId}/sessions/${sessionId}/complete`),
    type: COMPLETE_SESSION,
    sessionId,
  };
};

export const connectStripeExpressAccount = (userId, authorizationCode) => {
  return {
    promise: client.post(`users/${userId}/connect-stripe-express-account`, { authorization_code: authorizationCode }),
    type: CONNECT_STRIPE_EXPRESS_ACCOUNT,
  };
};

export const getStripeExpressLoginLink = userId => {
  return {
    promise: client.get(`users/${userId}/stripe-login-link`),
    type: GET_STRIPE_EXPRESS_LOGIN_LINK,
  };
};



// WEBPACK FOOTER //
// ./src/subscription/movement-specialist-admin/redux/actions.js